export const translations = {
  fr: {
    trust: "Données fiables mises à jour régulièrement par des experts.",
    langLabel: "Langue",
    premiumCta: "Contenu premium pour abonnés",
    subscribeCta: "S'abonner",
    subscribeFloatingCta: "S'abonner",
    heroTitle: "GEM PRICE",
    heroSubtitle: "La référence des prix des pierres précieuses",
    heroCriteria: "Origine · Qualité · Traitements · Prix par carat",
    allOrigins: "Toutes origines",
    gems: {
      sapphire: "SAPHIRS",
      ruby: "RUBIS",
      emerald: "ÉMERAUDES",
    },
    factSheets: "Fiches par pays d'origine",
    andOthers: "… et autres pays",
    pricingGrid: "Grille tarifaire par poids (carat)",
    pricingNote: "Prix par carat selon la qualité de la pierre (AAA, AA, A) et son origine.",
    detailedPricing: "Tarifs détaillés et complets",
    availableAfter: "Disponibles uniquement après abonnement",
    subscribedBadge: "Abonnement actif",
    selectCountryHint: "Cliquez ici pour voir les pays disponibles",
    viewDetailedPricing: "Voir les tarifs détaillés",
    features: {
      origin: { title: "Origine détaillée", desc: "Origine, caractéristiques et impact sur la valeur." },
      treatments: { title: "Traitements expliqués", desc: "Chauffé, huilé, comblé et leurs effets sur le prix." },
      synthetics: { title: "Synthétiques identifiés", desc: "Informations complètes sur les pierres de synthèse." },
      market: { title: "Données de marché", desc: "Prix mis à jour régulièrement." },
    },
    accessAll: "Accédez à toutes les fiches pays et tarifs détaillés après abonnement",
    origins: {
      sapphire: ["Sri Lanka (Ceylan)", "Madagascar", "Myanmar (Birmanie)", "Kashmir", "Australie", "Thaïlande", "Cambodge", "Nigéria", "Éthiopie", "Tanzanie"],
      ruby: ["Myanmar (Birmanie)", "Mozambique", "Madagascar", "Tanzanie", "Kenya", "Vietnam", "Thaïlande", "Malawi", "Afghanistan", "Cambodge", "Sri Lanka (Ceylan)", "Tadjikistan", "Pakistan"],
      emerald: ["Colombie", "Zambie", "Brésil", "Afghanistan", "Éthiopie", "Russie (Oural)", "Zimbabwe", "Madagascar", "Pakistan", "Chine", "Inde", "Égypte"],
    },
    modal: {
      title: "Choisissez votre abonnement",
      subtitle: "Accédez à toutes les données pour évaluer vos pierres en toute confiance.",
      expertHeading: "Des données d'experts",
      expertSub: "Références issues des laboratoires et du marché international.",
      bestOffer: "Meilleure offre",
      annualLabel: "Annuel",
      monthlyEquiv: "Soit 6,58 € / mois",
      perYear: "/ an",
      unlimitedAccess: "Accès illimité à TOUTES les tarifications — saphirs, rubis et émeraudes, tous pays d'origine confondus, toutes qualités (AAA / AA / A), et toutes plages de carats. Un seul abonnement, aucune limitation.",
      choose: "Choisir cette offre",
      loading: "Redirection vers Stripe…",
      close: "Fermer",
      includedTitle: "Inclus dans votre abonnement",
      included: {
        origin:     { title: "Provenance",       desc: "Découvrez l'origine de chaque pierre et son impact sur la valeur." },
        pricecarat: { title: "Prix au carat",    desc: "Consultez les prix de référence selon le poids et la qualité (AAA, AA, A)." },
        treatments: { title: "Traitements",      desc: "Identifiez les traitements et leur incidence sur la valeur." },
        synthetics: { title: "Synthétiques",     desc: "Informez-vous sur les pierres synthétiques et leurs différences." },
        sheets:     { title: "Fiches techniques", desc: "Accédez à nos fiches détaillées pour chaque pierre précieuse." },
      },
      trustLine: ["Données mises à jour régulièrement", "Sources fiables", "Informations à titre indicatif"],
      footerNote: "Paiement sécurisé. Résiliation en 1 clic.",
      availableOn: "Disponible sur",
      platforms: { web: "Web", appstore: "App Store", playstore: "Google Play" },
    },
    success: {
      title: "Paiement confirmé",
      body: "Merci ! Votre abonnement est actif. Vous avez maintenant accès à toutes les données premium.",
      cta: "Retour à l'accueil",
      pending: "Vérification du paiement en cours…",
    },
    cancel: {
      title: "Paiement annulé",
      body: "Votre paiement a été annulé. Vous pouvez reprendre à tout moment.",
      cta: "Retour à l'accueil",
    },
    footer: "© 2026 GEM PRICE. Tous droits réservés.",
    fiche: {
      pricingTitle: "Grille tarifaire",
      caratRange: "Poids (carat)",
      notFound: "Fiche non disponible.",
      lockedTitle: "Fiche réservée aux abonnés",
      lockedBody: "1 abonnement unique donne accès à toutes les tarifications — saphirs, rubis et émeraudes, toutes origines confondues, pour €79 / an.",
      lockedCta: "S'abonner",
      viewFullSize: "Voir en plein écran",
    },
    viewFiche: "Voir la fiche",
    contact: {
      eyebrow: "Contact",
      title: "Une question, un projet, une expertise ?",
      body: "Notre équipe reste à votre disposition pour tout renseignement sur nos données, votre abonnement ou une collaboration. Écrivez-nous directement.",
    },
  },
  en: {
    trust: "Reliable data regularly updated by experts.",
    langLabel: "Language",
    premiumCta: "Premium content for subscribers",
    subscribeCta: "Subscribe",
    subscribeFloatingCta: "Subscribe",
    heroTitle: "GEM PRICE",
    heroSubtitle: "The reference for precious gemstone prices",
    heroCriteria: "Origin · Quality · Treatments · Price per carat",
    allOrigins: "All origins",
    gems: {
      sapphire: "SAPPHIRES",
      ruby: "RUBIES",
      emerald: "EMERALDS",
    },
    factSheets: "Fact sheets by country of origin",
    andOthers: "… and other countries",
    pricingGrid: "Pricing grid by weight (carat)",
    pricingNote: "Price per carat based on the quality of the stone (AAA, AA, A) and its origin.",
    detailedPricing: "Detailed and complete pricings",
    availableAfter: "Available only after subscription",
    subscribedBadge: "Active subscription",
    selectCountryHint: "Click here to see available countries",
    viewDetailedPricing: "View detailed pricings",
    features: {
      origin: { title: "Detailed Origin", desc: "Origin, characteristics and impact on value." },
      treatments: { title: "Treatments Explained", desc: "Heated, oiled, filled and their effects on price." },
      synthetics: { title: "Identified Synthetics", desc: "Complete information on synthetic stones." },
      market: { title: "Market Data", desc: "Prices updated regularly." },
    },
    accessAll: "Access all country fact sheets and detailed pricings after subscription",
    origins: {
      sapphire: ["Sri Lanka (Ceylon)", "Madagascar", "Myanmar (Burma)", "Kashmir", "Australia", "Thailand", "Cambodia", "Nigeria", "Ethiopia", "Tanzania"],
      ruby: ["Myanmar (Burma)", "Mozambique", "Madagascar", "Tanzania", "Kenya", "Vietnam", "Thailand", "Malawi", "Afghanistan", "Cambodia", "Sri Lanka (Ceylon)", "Tajikistan", "Pakistan"],
      emerald: ["Colombia", "Zambia", "Brazil", "Afghanistan", "Ethiopia", "Russia (Urals)", "Zimbabwe", "Madagascar", "Pakistan", "China", "India", "Egypt"],
    },
    modal: {
      title: "Choose your subscription",
      subtitle: "Access all the data you need to evaluate your gemstones with confidence.",
      expertHeading: "Expert data",
      expertSub: "Compiled by gem experts. Trusted by thousands.",
      bestOffer: "Best offer",
      annualLabel: "Yearly",
      monthlyEquiv: "That's €6.58 / month",
      perYear: "/ year",
      unlimitedAccess: "Unlimited access to ALL pricing grids — sapphires, rubies and emeralds, every country of origin, every quality (AAA / AA / A) and every carat range. One single subscription, no restrictions.",
      choose: "Choose this offer",
      loading: "Redirecting to Stripe…",
      close: "Close",
      includedTitle: "Included in your subscription",
      included: {
        origin:     { title: "Origin",          desc: "Discover the origin of each gemstone and its impact on value." },
        pricecarat: { title: "Price per carat", desc: "Check reference prices by weight and quality (AAA, AA, A)." },
        treatments: { title: "Treatments",      desc: "Identify treatments and their impact on value." },
        synthetics: { title: "Synthetics",      desc: "Learn about synthetic stones and their differences." },
        sheets:     { title: "Data sheets",     desc: "Access our detailed data sheets for each precious gemstone." },
      },
      trustLine: ["Data regularly updated", "Reliable sources", "Information for guidance only"],
      footerNote: "Secure payment. Cancel in 1 click.",
      availableOn: "Available on",
      platforms: { web: "Web", appstore: "App Store", playstore: "Google Play" },
    },
    success: {
      title: "Payment confirmed",
      body: "Thank you! Your subscription is now active. You have full access to premium data.",
      cta: "Back to home",
      pending: "Verifying your payment…",
    },
    cancel: {
      title: "Payment cancelled",
      body: "Your payment was cancelled. You can resume at any time.",
      cta: "Back to home",
    },
    footer: "© 2026 GEM PRICE. All rights reserved.",
    fiche: {
      pricingTitle: "Pricing grid",
      caratRange: "Weight (carat)",
      notFound: "Fact sheet not available.",
      lockedTitle: "Subscribers only",
      lockedBody: "1 unique subscription unlocks all pricing — sapphires, rubies and emeralds, every origin included — for €79 / year.",
      lockedCta: "Subscribe",
      viewFullSize: "View full size",
    },
    viewFiche: "View fact sheet",
    contact: {
      eyebrow: "Contact",
      title: "A question, a project, an expertise?",
      body: "Our team is here to assist you with our data, your subscription or a partnership. Write to us directly.",
    },
  },
};

export const CARAT_BUCKETS = [
  "0.25 – 0.99 ct",
  "1.00 – 1.99 ct",
  "2.00 – 2.99 ct",
  "3.00 – 3.99 ct",
  "4.00 – 4.99 ct",
  "5.00 – 5.99 ct",
];
